import _Divider from './Divider';
import './style';

export type { DividerProps } from './Divider';
export * from './type';

export const Divider = _Divider;
export default Divider;
